export const BOTID_SCRIPT_PATH_PREFIX = '/149e9513-01fa-4fb0-aad4-566afd725d1b/'

export function isBotIdScriptLoadError(error: unknown): error is Event {
  const target = typeof Event !== 'undefined' && error instanceof Event ? error.target : null
  if (
    typeof Event === 'undefined' ||
    !(error instanceof Event) ||
    error.type !== 'error' ||
    typeof HTMLScriptElement === 'undefined' ||
    !(target instanceof HTMLScriptElement)
  ) {
    return false
  }

  try {
    return new URL(target.src).pathname.startsWith(BOTID_SCRIPT_PATH_PREFIX)
  } catch {
    return false
  }
}

export function describeBotIdScriptFailure(event: Event): {
  script: string
  status: number | null
} {
  let src = ''
  let script = 'unknown'
  const target = event.target

  if (typeof HTMLScriptElement !== 'undefined' && target instanceof HTMLScriptElement) {
    src = target.src
    try {
      script = new URL(src).pathname.split('/').at(-1) || 'unknown'
    } catch {
      return { script, status: null }
    }
  }

  if (
    !src ||
    typeof performance === 'undefined' ||
    typeof performance.getEntriesByName !== 'function'
  ) {
    return { script, status: null }
  }

  try {
    const entry = performance.getEntriesByName(src, 'resource').at(-1)
    if (!entry || !('responseStatus' in entry) || typeof entry.responseStatus !== 'number') {
      return { script, status: null }
    }
    return { script, status: entry.responseStatus }
  } catch {
    return { script, status: null }
  }
}
